import { useEffect, useState } from "react";
import { SlotCardSkeleton } from "../SlotCardSkeleton/SlotCardSkeleton";

interface ILobbySlotsSkeletonSectionProps {
  perPage: number;
  isLoading: boolean;
}
export const LobbySlotsSkeletonSection = ({
  perPage,
  isLoading,
}: ILobbySlotsSkeletonSectionProps) => {
  const [skeletonArray, setSkeletonArray] = useState<number[]>([]);
  useEffect(() => {
    const array = [];
    for (let index = 0; index < perPage; index++) {
      array.push(index);
    }
    setSkeletonArray(array);
  }, [perPage]);
  if (isLoading) {
    return (
      <>
        {skeletonArray.map((item) => (
          <SlotCardSkeleton key={`skeleton_${item}`} />
        ))}
      </>
    );
  } else {
    return null;
  }
};
